const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/userDefs.ts';
/**
 * common/usersDefs.ts
 *
 * Definitions concerning the currently logged-in user.
 *
 * Important notes on access codes:
 *
 *    - A user who has the right REGSEEANS
 *       - has access to objects requiring the same right (REGSEEANS)
 *       - has access to objects requiring a more specific right (e.g. REGSEEANSZWA)
 *       - has NO access to objects requiring a superior right (e.g. REGSEE)
 *       - has access to objects requiring the wildcard right of the same level (REGSEEANS*)
 *       - has access to objects requiring the wildcard right of a superior level (e.g. REGSEE*)
 *       - has access to objects requiring the wildcard right of a more specific level (e.g. REGSEEANSZWA*)
 *
 * Access codes starting with MOB are solely used by kisim-mobile. We may define any access
 * codes in that subtree as long as the 3-letter-based, hierarchical structure is maintained.
 *
 * Extended access codes are an extension by kisim-mobile:
 *
 *    'USZ:BLAFAS|UKBAL:BLABLP|BLABLA'  // BLAFAS for USZ, BLABLP for UKBAL, BLABLA otherwise
 *
 * For a more complete description of these, see AccessRightsUtils.translateAccessCode.
 */

/**
 * Value for state.user->{accessCode> when access is granted.
 */
export const ACCESS_GRANTED = 'grant';

/**
 * Value for state.user->{accessCode> when access is denied.
 */
export const ACCESS_DENIED = 'deny';

/**
 * Value for state.user->{accessCode} while the code is being loaded.
 */
export const ACCESS_LOADING = 'loading';

/**
 * Value for state.user->{accessCode} when the code could not be loaded.
 */
export const ACCESS_FAILURE = 'failure';

/**
 * The access code '*' will always evaluate to true. UserRightsGuard will not bother KISAPI
 * at all when this access code is queried. The result will not be written into the state.
 */
export const ANYBODY = '*';

/**
 * The null access code does not exist in QSCRIPT and is an extension of UserRightsGuard.
 * It will always evaluate to false. KISAPI is not queried when evaluating this.
 */
export const NOBODY: any = null;

/**
 * The empty access code '' means 'inherited from parent' in nested structures, and will evaluate
 * to false if there is no parent. When used outside of the context of a nested structure, the
 * empty access code will always evaluate to false. It's likely we're never going to use this
 * constant, because KISAPI already handles the rights of nested structures (MetaKat).
 */
export const PARENT_RIGHTS = '';

/**
 * Only CISTEC super admins have this right. It's about the only access code breaking
 * out of the 3-letter scheme of access codes.
 */
export const DEVELOPERS = 'ADMIN';

/**
 * Only CISTEC super admins and IT administrators of a hospital have this right.
 */
export const STAFF = 'LOCADM';
